export function extractLegalSlug(url: string): string | undefined {
    const normalizedUrl = url.replace(/^\/+|\/+$/g, "");

    const segments = normalizedUrl.split("/");
    const legalIndex = segments.indexOf("legal");

    if (legalIndex !== -1 && legalIndex + 1 < segments.length) {
        const slug = segments.slice(legalIndex + 1).join("/");
        return slug || undefined;
    }

    if (normalizedUrl === "legal") {
        return undefined;
    }

    return normalizedUrl || undefined;
}

export function scrollToExpandedPanel(
    document: Document,
    elementId: string,
    offset: number = 0,
    scrollPadding: number = 0,
): void {
    const element = document.getElementById(elementId);
    if (element) {
        const elementPosition =
            element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - offset - scrollPadding;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    }
}
